import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  makeStyles,
  useTheme
} from '@material-ui/core';
//import LaptopMacIcon from '@material-ui/icons/LaptopMac';
//import PhoneIcon from '@material-ui/icons/Phone';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  }
}));

const FormPieChart = ({ className, 
  ApprovedArrayPercentage, 
  RejectedArrayPercentage, 
  PendingArrayPercentage, totalArray, ...rest }) => {
  const classes = useStyles();
  const theme = useTheme();

  const data = {
    datasets: [
      {
        data: [PendingArrayPercentage, ApprovedArrayPercentage, RejectedArrayPercentage],
        backgroundColor: [
          colors.red[900],
          colors.green[600],
          colors.orange[600]
        ],
        borderWidth: 8,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white
      }
    ],
    labels: ['Pending', 'Approved', 'Rejected']
  };

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: true
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };
  const pendingData = totalArray === 0 ? '......' : PendingArrayPercentage.toFixed(2)
  const approvedData = totalArray === 0 ? '......' : ApprovedArrayPercentage.toFixed(2)
  const rejectedData = totalArray === 0 ? '......' : RejectedArrayPercentage.toFixed(2)
  const devices = [
    {
      title: 'Pending',
      value: pendingData,
      icon: HourglassFullIcon,
      color: colors.red[900],
    },
    {
      title: 'Approved',
      value: approvedData,
      icon: ThumbUpIcon,
      color: colors.green[600]

    },
    {
      title: 'Rejected',
      value: rejectedData,
      icon: ThumbDownIcon,
      color: colors.orange[600]
    }
  ];

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader title="Forms Pie Chart" />
      <Divider />
      <CardContent>
        <Box
          height={300}
          position="relative"
        >
          <Doughnut
            data={data}
            options={options}
          />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
        >
          {devices.map(({
            color,
            icon: Icon,
            title,
            value
          }) => (
            <Box
              key={title}
              p={1}
              textAlign="center"
            >
              <Icon color="action" />
              <Typography
                color="textPrimary"
                variant="body1"
              >
                {title}
              </Typography>
              <Typography
                style={{ color }}
                variant="h2"
              >
                {value}
                %
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

FormPieChart.propTypes = {
  className: PropTypes.string
};

export default FormPieChart;
